import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  SampleBaseDataTableFilters,
  useDefaultSampleBaseDataListRequest,
} from "@/services/backend/samples/components/sample-base-data-table";
import { DustDensityBaseDataTable } from "@/services/backend/samples/components/dust-density-base-data-table";
import { CreateDustDensityBaseDataDialog } from "@/services/backend/samples/components/create-dust-density-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function DustDensityBaseDataListRoute() {
  const [request, setRequest] = useState(useDefaultSampleBaseDataListRequest());

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Staubdichtemessungen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen eine neue Staubdichtemessung angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateDustDensityBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <SampleBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <DustDensityBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
